import {Component, Input} from '@angular/core';
import {environment} from '../../environments/environment';

@Component({
    selector: 'burncase-tbsa-results',
    templateUrl: './tbsa-results.component.html',
    styleUrls: ['./tbsa-results.component.css']
})
export class TbsaResultsComponent {

    @Input() data: [];
    @Input() finish: boolean;
    @Input() total: string;
    @Input() parkland: string;

    private _displayedColumns = ['degree', 'percent'];
    version = environment.Version;

    constructor() {
    }

    get displayedColumns(): string[] {
        return this._displayedColumns;
    }
}
